import axios from '../base/axios';
import API_KEY from './key';

const GET_TVFAMILY = 'flixfrenzy/redux/GET_TVFAMILY';

// eslint-disable-next-line default-param-last
const tvFamilyReducer = (state = [], action) => {
  switch (action.type) {
    case GET_TVFAMILY:
      return action.payload;
    default:
      return state;
  }
};

export const getTvFamily = () => (dispatch) => {
  axios.get(`discover/tv?api_key=${API_KEY}&with_genres=10751`).then((res) => {
    dispatch({
      type: GET_TVFAMILY,
      payload: res.data,
    });
  });
};

export default tvFamilyReducer;
